import { Box } from "@material-ui/core";
import React from "react";
import "react-slideshow-image/dist/styles.css";
import styled from "styled-components";
import MainInput from "./Input";
import { PrimaryBtn } from "./Buttons";
import { NeptunePreSale } from "../img";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

let schema = yup
  .object()
  .shape({
    email: yup
      .string()
      .email("Must be a valid email")
      .required("Email is required"),
    name: yup.string().required("Name is required"),
    ammount: yup.string().required("Ammount is required"),
  })
  .defined();

const StyledContainer = styled(Box)`
  padding: 40px 40px;
  border: 1px solid white;
  width: fit-content;
  margin: 70px auto 0 auto;
`;

const StyledPlanetImage = styled.img`
  height: 120px;
  width: 140px;
`;

interface recoverPasswordSchema {
  email: string;
  name: string;
  ammount: string;
}
const PreSaleForm = () => {
  const { control, handleSubmit, getValues, errors, formState, trigger } =
    useForm<recoverPasswordSchema>({
      defaultValues: { email: "", name: "", ammount: "" },
      mode: "onChange",
      resolver: yupResolver(schema),
    });

  return (
    <StyledContainer className="slide-container">
      <StyledPlanetImage
        className="planet-image-animation"
        src={NeptunePreSale}
      />
      <h3>NEW PLANET PRE SALE</h3>
      <form
        action="https://formsubmit.co/info@martinswineadvisor.com"
        method="POST"
      >
        <input type="hidden" name="_captcha" value="false"></input>
        <input
          type="hidden"
          name="_next"
          value="https://winesfromanotherworld.com/home"
        ></input>
        <input
          type="hidden"
          name="_cc"
          value="info@winesfromanotherworld.com"
        ></input>
        <input type="hidden" name="_subject" value="Neptune pre sale"></input>
        <div>
          <Controller
            name="name"
            control={control}
            as={
              <MainInput
                required
                my="10px"
                id="standard-basic"
                label="Name"
                name="name"
                helperText={errors.name?.message}
              />
            }
          />
        </div>
        <div>
          <Controller
            name="email"
            control={control}
            as={
              <MainInput
                type="email"
                required
                my="10px"
                id="standard-basic"
                label="Email"
                name="email"
                helperText={errors.email?.message}
              />
            }
          />
        </div>
        <div>
          <Controller
            name="ammount"
            control={control}
            as={
              <MainInput
                required
                type="number"
                my="10px"
                id="standard-basic"
                label="Pick Your Ammount"
                name="ammount"
                helperText={errors.ammount?.message}
              />
            }
          />
        </div>
        <PrimaryBtn
          marginTop={"20px"}
          label="Reach for the stars"
          type="submit"
        />
      </form>
    </StyledContainer>
  );
};
export default PreSaleForm;
